/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const iframe = document.querySelector( 'iframe' );
      const player = new Vimeo.Player( iframe );

      player.on( 'ended', function() {
        updateUserCompletedVideos();
      } );

      function updateUserCompletedVideos() {
        let doingAjax = true;
        const data = {
          'user_id': $( '.single-video' ).attr( 'data-user-id' ),
          'post_id': $( '.single-video' ).attr( 'data-post-id' ),
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/updateUserCompletedVideos',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            if ( data.buttonStatus == 'add' ) {
              $( button ).addClass( 'bookmarked' );
            } else {
              $( button ).removeClass( 'bookmarked' );
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'video', COMPONENT );
} )( app );
